import { creditHistoryConstants } from "./creditHistory.constants";
import { creditHistoryService } from "services";

export const creditHistoryActions = {
	setBanks,
	sendCreditHistory,
};

function setBanks(banks) {
	return {
		type: creditHistoryConstants.SET_BANKS,
		banks,
	};
}

function sendCreditHistory(payload) {
	return (dispatch) => {
		dispatch(request());
		return creditHistoryService
			.sendCreditHistory(payload)
			.then(
				result => {
					dispatch(success());
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request() {
		return {
			type: creditHistoryConstants.SEND_CREDIT_HISTORY_REQUEST,
		};
	}

	function success() {
		return {
			type: creditHistoryConstants.SEND_CREDIT_HISTORY_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: creditHistoryConstants.SEND_CREDIT_HISTORY_ERROR,
			error,
		};
	}
}
